import { IsString, IsNotEmpty, IsBoolean } from 'class-validator';

export class BaseEventFieldsDto {
  @IsString()
  @IsNotEmpty({ message: 'Обязательное поле' })
  stageName: string;

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  notifyIntegration: boolean;
}
